import {
  faUserHeadset as fasUserHeadset, faUsers as fasUsers, faUserPen as fasUserPen,
  faSackDollar as fasSackDollar, faCircleExclamation as fasCircleExclamation,
  faSortDown as fasSortDown, faCaretLeft as fasCaretLeft, faCaretRight as fasCaretRight,
  faShieldCheck as fasShieldCheck, faCircleSmall as fasCircleSmall, faFilterList as fasFilterList,
  faCircleQuestion as fasCircleQuestion, faMoneyBillTransfer as fasMoneyBillTransfer,
  faFileInvoiceDollar as fasFileInvoiceDollar, faHome as fasHome, faEye as fasEye, faEyeSlash as fasEyeSlash,
  faUpload as fasUpload, faFileCircleCheck as fasFileCircleCheck
} from '@fortawesome/pro-solid-svg-icons';
import {
  faChevronRight as farChevronRight, faEllipsis as farEllipsis, faEdit as farEdit,
  faFileContract as farFileContract, faTrashCan as farTrashCan, faEye as farEye,
  faEllipsisVertical as farEllipsisVertical, faXmark as farXmark, faCameraRotate as farCameraRotate,
  faCameraWebSlash as farCameraWebSlash, faCamera as farCamera, faLink as farLink, faArrowRight as farArrowRight,
  faCircleCheck as farCircleCheck, faArrowUpRightFromSquare as farArrowUpRightFromSquare, faLock as farLock,
  faGripDotsVertical as farGripDotsVertical, faCircleQuestion as farCircleQuestion, faEllipsisV as farEllipsisV,
  faPersonCircleQuestion as farPersonCircleQuestion, faUserTie as farUserTie, faIndustryWindows as farIndustryWindows,
  faArrowTurnDownRight as farArrowTurnDownRight, faEllipsisH as farEllipsisH, faSpinner as farSpinner
} from '@fortawesome/pro-regular-svg-icons';
import {
  faKaaba as falKaaba, faUserHeadset as falUserHeadset, faUsers as falUsers, faUserPen as falUserPen,
  faUsersViewfinder as falUsersViewfinder, faListCheck as falListCheck, faCirclePlus as falCirclePlus,
  faNetworkWired as falNetworkWired, faCircleDollar as falCircleDollar, faSlidersUp as falSlidersUp,
  faRulerTriangle as falRulerTriangle, faFileUser as falFileUser, faFileLines as falFileLines,
  faFileInvoiceDollar as falFileInvoiceDollar, faArrowProgress as falArrowProgress,
  faBadgePercent as falBadgePercent, faCalculatorSimple as falCalculatorSimple, faUser as falUser,
  faArrowUpFromBracket as falArrowUpFromBracket, faBox as falBox, faHandHoldingDollar as falHandHoldingDollar,
  faPersonFromPortal as falPersonFromPortal, faXmark as falXmark, faChevronDown as falChevronDown,
  faArrowLeft as falArrowLeft, faFileContract as falFileContract, faPenField as falPenField,
  faCircleCheck as falCircleCheck, faThumbTack as falThumbTack, faLinkSimpleSlash as falLinkSimpleSlash,
  faSignature as falSignature, faRadar as falRadar, faMagnifyingGlass as falMagnifyingGlass,
  faEye as falEye, faAnglesUpDown as falAnglesUpDown, faCalendar as falCalendar, faTimes as falTimes,
  faPlus as falPlus, faFilterList as falFilterList, faChevronLeft as falChevronLeft,
  faChevronRight as falChevronRight, faCircleArrowUp as falCircleArrowUp, faCircleArrowDown as falCircleArrowDown,
  faCameraRotate as falCameraRotate, faArrowUpRightAndArrowDownLeftFromCenter as falArrowUpRightAndArrowDownLeftFromCenter,
  faArrowDownLeftAndArrowUpRightToCenter as falArrowDownLeftAndArrowUpRightToCenter, faTrashCan as falTrashCan,
  faUpload as falUpload, faPercent as falPercent, faDollarSign as falDollarSign, faDownload as falDownload,
  faMinus as falMinus, faTimer as falTimer, faCheck as falCheck, faPaperPlane as falPaperPlane, faEyeSlash as falEyeSlash,
  faPersonDigging as falPersonDigging, faTrafficCone as falTrafficCone, faCalculator as falCalculator,
  faFloppyDisk as falFloppyDisk, faLink as falLink, faCameraViewfinder as falCameraViewfinder,
  faLampDesk as falLampDesk, faBoltLightning as falBoltLightning, faAddressCard as falAddressCard,
  faGlasses as falGlasses, faImagePolaroidUser as falImagePolaroidUser, faFaceViewfinder as falFaceViewfinder,
  faEdit as falEdit, faFileAlt as falFileAlt, faDollar as falDollar, faClock as falClock, faUsersRays as falUsersRays,
  faFileCsv as falFileCsv, faFileExcel as falFileExcel, faTrashAlt as falTrashAlt, faSquare as falSquare,
  faSquareCheck as falSquareCheck, faUserPlus as falUserPlus, faSearch as falSearch, faCircleXmark as falCircleXmark,
  faArrowsRotate as falArrowsRotate, faBuildingColumns as falBuildingColumns, faPencil as falPencil,
  faChartSimple as falChartSimple, faCashRegister as falCashRegister, faRocketLaunch as falRocketLaunch,
  faArrowsTurnToDots as falArrowsTurnToDots, faSyncAlt as falSyncAlt, faFilePdf as falFilePdf,
  faPenToSquare as falPenToSquare, faCabinetFiling as falCabinetFiling, faGripDotsVertical as falGripDotsVertical,
  faEllipsisH as falEllipsisH, faPlusCircle as falPlusCircle, faLock as falLock, faCopy as falCopy,
  faBroomWide as falBroomWide, faBrowser as falBrowser, faCircleMinus as falCircleMinus,
  faShieldTimes as falShieldTimes, faShieldCheck as falShieldCheck, faKey as falKey,
  faMoneyBillTrendUp as falMoneyBillTrendUp, faUsersMedical as falUsersMedical, faCircleInfo as falCircleInfo,
  faFileCertificate as falFileCertificate, faMagnifyingGlassPlus as falMagnifyingGlassPlus,
  faArrowUpRightFromSquare as falArrowUpRightFromSquare, faCoins as falCoins

} from '@fortawesome/pro-light-svg-icons';

export const AppIcons = {
  //Solid
  fasCaretLeft: fasCaretLeft,
  fasCaretRight: fasCaretRight,
  fasCircleExclamation: fasCircleExclamation,
  fasFileCircleCheck: fasFileCircleCheck,
  fasCircleQuestion: fasCircleQuestion,
  fasCircleSmall: fasCircleSmall,
  fasFileInvoiceDollar: fasFileInvoiceDollar,
  fasFilterList: fasFilterList,
  fasEye: fasEye,
  fasEyeSlash: fasEyeSlash,
  fasHome: fasHome,
  fasMoneyBillTransfer: fasMoneyBillTransfer,
  fasSackDollar: fasSackDollar,
  fasShieldCheck: fasShieldCheck,
  fasSortDown: fasSortDown,
  fasUpload: fasUpload,
  fasUsers: fasUsers,
  fasUserHeadset: fasUserHeadset,
  fasUserPen: fasUserPen,
  // Regular
  farArrowRight: farArrowRight,
  farArrowUpRightFromSquare: farArrowUpRightFromSquare,
  farCamera: farCamera,
  farCameraRotate: farCameraRotate,
  farCameraWebSlash: farCameraWebSlash,
  farChevronRight: farChevronRight,
  farCircleCheck: farCircleCheck,
  farCircleQuestion: farCircleQuestion,
  farEllipsis: farEllipsis,
  farEllipsisH: farEllipsisH,
  farEllipsisV: farEllipsisV,
  farEllipsisVertical: farEllipsisVertical,
  farEdit: farEdit,
  farEye: farEye,
  farFileContract: farFileContract,
  farGripDotsVertical: farGripDotsVertical,
  farIndustryWindows: farIndustryWindows,
  farLink: farLink,
  farLock: farLock,
  farPersonCircleQuestion: farPersonCircleQuestion,
  farSpinner: farSpinner,
  farTrashCan: farTrashCan,
  farUserTie: farUserTie,
  farXmark: farXmark,
  // Light
  falAddressCard: falAddressCard,
  falAnglesUpDown: falAnglesUpDown,
  falArrowDownLeftAndArrowUpRightToCenter: falArrowDownLeftAndArrowUpRightToCenter,
  falArrowLeft: falArrowLeft,
  falArrowProgress: falArrowProgress,
  farArrowTurnDownRight: farArrowTurnDownRight,
  falArrowUpFromBracket: falArrowUpFromBracket,
  falArrowUpRightAndArrowDownLeftFromCenter: falArrowUpRightAndArrowDownLeftFromCenter,
  falArrowUpRightFromSquare: falArrowUpRightFromSquare,
  falArrowsRotate: falArrowsRotate,
  falArrowsTurnToDots: falArrowsTurnToDots,
  falBadgePercent: falBadgePercent,
  falBoltLightning: falBoltLightning,
  falBox: falBox,
  falBroomWide: falBroomWide,
  falBrowser: falBrowser,
  falBuildingColumns: falBuildingColumns,
  falCabinetFiling: falCabinetFiling,
  falCalculator: falCalculator,
  falCalculatorSimple: falCalculatorSimple,
  falCalendar: falCalendar,
  falCameraRotate: falCameraRotate,
  falCameraViewfinder: falCameraViewfinder,
  falCashRegister: falCashRegister,
  falChartSimple: falChartSimple,
  falCheck: falCheck,
  falChevronDown: falChevronDown,
  falChevronLeft: falChevronLeft,
  falChevronRight: falChevronRight,
  falCircleArrowDown: falCircleArrowDown,
  falCircleArrowUp: falCircleArrowUp,
  falCircleCheck: falCircleCheck,
  falCircleDollar: falCircleDollar,
  falCircleInfo: falCircleInfo,
  falCircleMinus: falCircleMinus,
  falCirclePlus: falCirclePlus,
  falCircleXmark: falCircleXmark,
  falClock: falClock,
  falCoins: falCoins,
  falCopy: falCopy,
  falDollar: falDollar,
  falDollarSign: falDollarSign,
  falDownload: falDownload,
  falEdit: falEdit,
  falEllipsisH: falEllipsisH,
  falEye: falEye,
  falEyeSlash: falEyeSlash,
  falFaceViewfinder: falFaceViewfinder,
  falFileAlt: falFileAlt,
  falFileCertificate: falFileCertificate,
  falFileContract: falFileContract,
  falFileCsv: falFileCsv,
  falFileExcel: falFileExcel,
  falFileInvoiceDollar: falFileInvoiceDollar,
  falFileLines: falFileLines,
  falFilePdf: falFilePdf,
  falFileUser: falFileUser,
  falFilterList: falFilterList,
  falFloppyDisk: falFloppyDisk,
  falGlasses: falGlasses,
  falGripDotsVertical: falGripDotsVertical,
  falHandHoldingDollar: falHandHoldingDollar,
  falImagePolaroidUser: falImagePolaroidUser,
  falKaaba: falKaaba,
  falKey: falKey,
  falLampDesk: falLampDesk,
  falLink: falLink,
  falLinkSimpleSlash: falLinkSimpleSlash,
  falListCheck: falListCheck,
  falLock: falLock,
  falMagnifyingGlass: falMagnifyingGlass,
  falMagnifyingGlassPlus: falMagnifyingGlassPlus,
  falMinus: falMinus,
  falMoneyBillTrendUp: falMoneyBillTrendUp,
  falNetworkWired: falNetworkWired,
  falPaperPlane: falPaperPlane,
  falPencil: falPencil,
  falPenField: falPenField,
  falPenToSquare: falPenToSquare,
  falPercent: falPercent,
  falPersonDigging: falPersonDigging,
  falPersonFromPortal: falPersonFromPortal,
  falPlus: falPlus,
  falPlusCircle: falPlusCircle,
  falRadar: falRadar,
  falRocketLaunch: falRocketLaunch,
  falRulerTriangle: falRulerTriangle,
  falSearch: falSearch,
  falShieldCheck: falShieldCheck,
  falShieldTimes: falShieldTimes,
  falSignature: falSignature,
  falSlidersUp: falSlidersUp,
  falSquare: falSquare,
  falSquareCheck: falSquareCheck,
  falSyncAlt: falSyncAlt,
  falThumbTack: falThumbTack,
  falTimes: falTimes,
  falTimer: falTimer,
  falTrafficCone: falTrafficCone,
  falTrashAlt: falTrashAlt,
  falTrashCan: falTrashCan,
  falUpload: falUpload,
  falUser: falUser,
  falUserHeadset: falUserHeadset,
  falUsersMedical: falUsersMedical,
  falUserPen: falUserPen,
  falUserPlus: falUserPlus,
  falUsers: falUsers,
  falUsersRays: falUsersRays,
  falUsersViewfinder: falUsersViewfinder,
  falXmark: falXmark
};
